import { render, staticRenderFns } from "./BannerImgPopUp.vue?vue&type=template&id=a3681a98&scoped=true&"
import script from "./BannerImgPopUp.vue?vue&type=script&lang=js&"
export * from "./BannerImgPopUp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3681a98",
  null
  
)

export default component.exports